document.body.addEventListener('click', function(e) {
  // 检查点击目标是否是.des_title下的a标签
  const targetLink = e.target.closest('.des_title a');
  if (!targetLink) return; // 不是目标元素则退出

  // 获取相关元素
  const selfTitle = targetLink.parentElement; // .des_title元素
  const container = selfTitle.parentElement; // 共同父容器
  const selfContent = container.querySelector('.des_content'); // 对应的内容元素

  // 检查内容是否隐藏
  const isHidden = getComputedStyle(selfContent).display === 'none';

  if (isHidden) {
    // 展开逻辑
    selfTitle.classList.add('active');
    // 显示动画（500ms）
    selfContent.style.transition = 'all 500ms ease';
    selfContent.style.display = 'block';
    // 触发重排后设置高度相关样式（确保动画生效）
    setTimeout(() => {
      selfContent.style.opacity = '1';
      selfContent.style.maxHeight = selfContent.scrollHeight + 'px';
    }, 10);
  } else {
    // 折叠逻辑
    selfTitle.classList.remove('active');
    // 隐藏动画（500ms）
    selfContent.style.transition = 'all 500ms ease';
    selfContent.style.opacity = '0';
    selfContent.style.maxHeight = '0';
    // 动画结束后隐藏元素
    setTimeout(() => {
      selfContent.style.display = 'none';
    }, 500);
  }
});
